import * as yup from 'yup';
import { z } from 'zod';

export const ZIP_CODE_LENGTH = 5;
export const ZIP_CODE_VALIDATION_MESSAGE = 'Must be a valid ZIP code';
export const ERROR_MESSAGE_FIVE_DIGITS = 'ZIP code should be 5-digit';
export const ERROR_MESSAGE_POSITIVE = 'The number must be positive';
export const ERROR_MESSAGE_REQUIRED_ZIP_CODE = 'Required ZIP code';

export const zipCodeValidationSchema = yup
  .string()
  .test('len', ERROR_MESSAGE_FIVE_DIGITS, value => {
    const length = value?.toString().length || 0;
    return length === ZIP_CODE_LENGTH;
  })
  .test('positive', ERROR_MESSAGE_POSITIVE, value => {
    const zipCode = value || 0;
    return +zipCode >= 0;
  })
  .typeError(ZIP_CODE_VALIDATION_MESSAGE);

export const zipCodeZodValidationSchema = z
  .string(ZIP_CODE_VALIDATION_MESSAGE)
  .length(ZIP_CODE_LENGTH, ERROR_MESSAGE_FIVE_DIGITS)
  .refine(
    value => {
      return z.int().positive().safeParse(Number.parseInt(value, 10)).success;
    },
    { error: ERROR_MESSAGE_POSITIVE },
  );
